import { Box, Typography } from '@mui/material';
import { FC } from 'react';
import { ITemplate } from '../../../../resource';
import { getTemplateComponents } from '../../../PDFViewerV2/components/templates';

type Props = {
  template?: ITemplate;
};

/**
 * Templates are coded React-PDF / pdfmake layouts keyed by Mongo _id.
 * This page is metadata + access only — not a visual designer.
 */
export const LayoutInfo: FC<Props> = ({ template }) => {
  const id = template?._id;
  const hasReactPdfRegistry = !!getTemplateComponents(id);
  // Schema default is pdf-maker; older Mongo docs often omit `type` entirely.
  const rawType = template?.type;
  const effectiveType = rawType || 'pdf-maker';
  const typeNote = rawType
    ? effectiveType
    : 'pdf-maker (field unset in DB — schema default)';

  return (
    <Box sx={{ mb: 8 }}>
      <Typography variant="h5" fontWeight={500} mb={12}>
        Layout
      </Typography>
      <Typography variant="body2" sx={{ opacity: 0.85, mb: 8 }}>
        Page layout is not edited here. Each template&apos;s PDF look is implemented in code and
        selected by this template&apos;s id. Changes above (title, theme, icons, publish) update
        metadata only — they do not redesign the factsheet pages.
      </Typography>
      <Typography variant="body2" sx={{ fontFamily: 'monospace', mb: 4 }}>
        Template id: {id || '—'}
      </Typography>
      <Typography variant="body2" sx={{ opacity: 0.7, mb: 2 }}>
        Renderer type: {typeNote}
      </Typography>
      <Typography variant="body2" sx={{ opacity: 0.7 }}>
        {hasReactPdfRegistry
          ? 'React-PDF: coded layout registered in the app (V2 editor / react-pdf PDF).'
          : 'Classic pdfmake path (V1 editor). No React-PDF layout is registered for this id.'}
      </Typography>
    </Box>
  );
};
